var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_350)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_129_350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H100V100H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_129_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0498 4.69169C74.0574 11.5065 66.1531 17.1446 57.9043 20.8005C48.5242 24.9577 38.7006 26.278 29.1016 26.1391V46.9473V67.7462C38.7006 67.6071 48.5242 68.9182 57.9043 73.0755C66.0717 76.6952 73.9014 82.2647 81.8133 88.986",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3516 90.8203C91.8059 90.8203 97.0703 71.0793 97.0703 46.875C97.0703 22.6707 91.8059 2.92969 85.3516 2.92969C78.8971 2.92969 73.6328 22.6707 73.6328 46.875C73.6328 71.0793 78.8971 90.8203 85.3516 90.8203Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3398 33.5535C80.7754 34.5504 85.7428 40.1502 85.7428 46.8539C85.7428 53.3162 81.127 58.7525 75.0293 60.0289",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1016 26.1863H15.8203C8.72031 26.1863 2.92969 31.977 2.92969 39.077V54.8973C2.92969 61.9973 8.72031 67.7879 15.8203 67.7879H29.1016V26.1863Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4062 69.5313L33.5398 92.5188C32.5928 95.2729 30.1486 97.0703 27.2363 97.0703H26.9531C23.2955 97.0703 20.3125 94.0873 20.3125 90.4297V67.7879",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingIcon);
export default __webpack_public_path__ + "static/media/marketing-icon.df5d657704be7a0f6e1f846d800b60a9.svg";
export { ForwardRef as ReactComponent };